/**
 * DemocratCharts — drawing hotkeys.
 *
 *   T  → trend line tool
 *   H  → horizontal line tool
 *   E  → eraser
 *   Esc → cancel active tool / pending points
 *
 * Disabled inside input fields.
 */

import { useEffect } from "react";
import { useDrawingsStore } from "@/store/drawings";

export function useDrawingHotkeys() {
  const { activeTool, setTool, cancelPending } = useDrawingsStore();

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const tag = (e.target as HTMLElement)?.tagName?.toLowerCase();
      const isEditable =
        tag === "input" ||
        tag === "textarea" ||
        tag === "select" ||
        (e.target as HTMLElement)?.isContentEditable;
      if (isEditable) return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;

      switch (e.key) {
        case "t":
        case "T":
          e.preventDefault();
          setTool(activeTool === "trend" ? null : "trend");
          break;
        case "h":
        case "H":
          e.preventDefault();
          setTool(activeTool === "horizontal" ? null : "horizontal");
          break;
        case "f":
        case "F":
          e.preventDefault();
          setTool(activeTool === "fib_retracement" ? null : "fib_retracement");
          break;
        case "x":
        case "X":
          e.preventDefault();
          setTool(activeTool === "fib_extension" ? null : "fib_extension");
          break;
        case "c":
        case "C":
          e.preventDefault();
          setTool(activeTool === "cycle" ? null : "cycle");
          break;
        case "e":
        case "E":
          e.preventDefault();
          setTool(activeTool === "eraser" ? null : "eraser");
          break;
        case "Escape":
          if (activeTool || useDrawingsStore.getState().pendingPoints.length > 0) {
            e.preventDefault();
            setTool(null);
            cancelPending();
          }
          break;
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [activeTool, setTool, cancelPending]);
}
